import { useCallback } from 'react';
import { useSnackbar } from 'notistack';

import { AUTO_HIDE_DURATION_TIME } from '@components/Notification';
import ChatNotification from '@core/chat/components/ChatNotification';
import { ShowChatNotificationType } from '@core/chat/components/ChatNotification/interfaces';

const useNotificationMessage = () => {
  const { enqueueSnackbar, closeSnackbar } = useSnackbar();

  const showChatNotification: ShowChatNotificationType = useCallback(
    ({ message, onReply, ...options }) => {
      const notificationId = enqueueSnackbar('', {
        autoHideDuration: AUTO_HIDE_DURATION_TIME,
        preventDuplicate: false,
        content(key) {
          return ChatNotification({
            id: key,
            message,
            onReply,
          });
        },
        ...options,
      });

      return notificationId;
    },
    [enqueueSnackbar],
  );

  return { showChatNotification };
};

export default useNotificationMessage;
